import {MediaLibraryScreen} from "@/components/media/media-library/MediaLibraryScreen";
import {useLocalSearchParams} from "expo-router";

export default function Library() {
    const {orgId} = useLocalSearchParams<{ orgId: string }>();
    return (
        <MediaLibraryScreen orgId={orgId}/>
    );
}
